import styled, { keyframes } from 'styled-components'
import { Item } from '@radix-ui/react-radio-group'

const rotate = keyframes`
  0% { transform: rotate(0deg) }
  100% { transform: rotate(360deg) }
`

const fadeUp = keyframes`
  0% {
    opacity: 0;
    transform: translateY(0.5rem);
  }
  50% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(0);
  }
`

export const Icon = styled.div`
  width: 1.8rem;
  height: 1.8rem;
  color: inherit;

  svg {
    color: inherit;
  }
`

export const SizeItem = styled(Item)<{ $isGiftCard: boolean }>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ $isGiftCard }) => ($isGiftCard ? '5rem' : '3.8rem')};
  height: ${({ $isGiftCard }) => ($isGiftCard ? '5rem' : '3.8rem')};
  background-color: ${({ theme }) => theme.colors.secondary};
  cursor: pointer;
  border: none;
  border-radius: 50%;
  line-height: 0;

  &:hover {
    background-color: ${({ theme }) => theme.colors.hover};
    color: ${({ theme }) => theme.colors.text.secondary};
  }

  &.unavailable {
    background-color: ${({ theme }) => theme.colors.secondary};
    color: ${({ theme }) => theme.colors.text.light};

    &::after {
      content: '';
      position: absolute;
      display: block;
      width: 100%;
      height: 0.2rem;
      background-color: ${({ theme }) => theme.colors.background};
      transform: rotate(-50deg);
    }
  }

  &[data-state='checked'] {
    background-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.text.secondary};

    &.loading {
      animation: ${rotate} 500ms steps(8, start) infinite;
    }

    &.error {
      background-color: ${({ theme }) => theme.colors.danger};
    }

    &.success {
      background-color: ${({ theme }) => theme.colors.primary};

      svg {
        animation: ${fadeUp} 1s forwards;
      }
    }
  }
`
